var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m9.683 8.673-1.1 1.113L2.213 2.5a.198.198 0 0 1 .014-.261.193.193 0 0 1 .258-.015l7.2 6.45ZM11.16 10.852l-.424.43 2.123 1.82a.068.068 0 0 0 .092-.005.07.07 0 0 0 .006-.093l-1.796-2.152Z",
    stroke: "#222",
    className: "stroke",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.582 9.788 9.68 8.675l1.405 1.423a.59.59 0 0 1 0 .83l-.28.283a.576.576 0 0 1-.82 0L8.583 9.788ZM4.439 5.045s-1.858.357-2.36.07a1.74 1.74 0 0 1-.325-.238 1.367 1.367 0 0 1-.112-.118l-.565-.654a.314.314 0 0 1 .127-.5l1.648-.374L4.44 5.045ZM4.997 4.478s.352-1.88.069-2.388a1.489 1.489 0 0 0-.348-.44l-.647-.573a.307.307 0 0 0-.493.13l-.37 1.668 1.789 1.603ZM9.537 13.228v.07c0 .678.199 1.341.571 1.905a3.398 3.398 0 0 0 1.52 1.264c.62.26 1.301.327 1.959.195a3.377 3.377 0 0 0 1.735-.939 3.468 3.468 0 0 0 .735-3.738 3.42 3.42 0 0 0-1.249-1.54 3.359 3.359 0 0 0-1.882-.577h-.089",
    stroke: "#222",
    className: "stroke",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.837 9.872h.089c.67 0 1.325.2 1.882.578a3.42 3.42 0 0 1 1.248 1.539 3.468 3.468 0 0 1-.735 3.738 3.377 3.377 0 0 1-1.734.939 3.35 3.35 0 0 1-1.958-.195c-.62-.26-1.149-.7-1.52-1.264a3.46 3.46 0 0 1-.572-1.905v-.07",
    stroke: "#222",
    className: "stroke",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.956 10.613a6.685 6.685 0 0 0-.316 4.483 6.608 6.608 0 0 0 2.59 3.652 6.47 6.47 0 0 0 8.316-.782 6.672 6.672 0 0 0 .755-8.42 6.533 6.533 0 0 0-3.613-2.613 6.457 6.457 0 0 0-4.429.33",
    stroke: "#222",
    className: "stroke",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.686 8.313a9.81 9.81 0 0 0-1.192 6.77 9.73 9.73 0 0 0 3.536 5.87 9.512 9.512 0 0 0 6.49 2.029 9.54 9.54 0 0 0 6.19-2.832 9.764 9.764 0 0 0 2.785-6.271 9.791 9.791 0 0 0-2.016-6.566 9.574 9.574 0 0 0-5.806-3.569c-2.3-.432-4.678.001-6.685 1.22",
    stroke: "#222",
    className: "stroke",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.26 7.262a6.454 6.454 0 0 1 4.426-.329 6.53 6.53 0 0 1 3.61 2.613 6.668 6.668 0 0 1-.754 8.416 6.467 6.467 0 0 1-8.312.782 6.604 6.604 0 0 1-2.59-3.65 6.683 6.683 0 0 1 .316-4.482",
    stroke: "#222",
    className: "stroke",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDart);
export default __webpack_public_path__ + "static/media/dart.fd477b39.svg";
export { ForwardRef as ReactComponent };